<div *ngIf="!displayWarningMsg && !dataAlreadyPresent" class="flex flex-col">
    <div class="flex justify-between mb-1">
        <h3 class="site-name-color">{{dashboardService.translate('DOWNLOAD REPORT')}}</h3>
        <span class="flex items-center " mat-dialog-close mat-icon-button
            style="cursor: pointer">
            <mat-icon [svgIcon]="'custom:close'"></mat-icon>
        </span>
    </div>
</div>
<hr *ngIf="!displayWarningMsg && !dataAlreadyPresent" class="w-full my-4">
<div *ngIf="!displayWarningMsg && !dataAlreadyPresent" class="flex justify-center flex-row w-full">

    <button (click)="onDownloadShapefileClick()" [disabled]="disableDownloadButtonsForWO"
        class="bg-[#15254f] hover:shadow-lg text-grey-darkest mr-2 py-2 px-4 rounded inline-flex items-center
         disabled:bg-[#72798C] hover:shadow-none">
        <svg class="w-4 h-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path fill="#FFFFFF" d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
        </svg>
        <span class="text-white">{{dashboardService.translate('SHAPEFILE')}}</span>
    </button>
    <button (click)="onDownloadExcelClick()"
        class="bg-green-500 text-white hover:shadow-lg hover:bg-green-600 text-grey-darkest py-2 px-4 rounded inline-flex items-center">
        <svg class="w-4 h-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path fill="#FFFFFF" d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
        </svg>
        <span>{{dashboardService.translate('EXCEL FORMAT')}}</span>
    </button>
    <button (click)="onDownloadPdfClick()" [disabled]="disableDownloadButtonsForWO"
        class="bg-red-600 hover:shadow-lg text-grey-darkest ml-2 py-2 px-4 rounded inline-flex items-center disabled:bg-red-200 hover:shadow-none">
        <svg class="w-4 h-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path fill="#FFFFFF" d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
        </svg>
        <span class="text-white">{{dashboardService.translate('PDF FORMAT')}}</span>
    </button>

</div>

<!-- /* to display the info instead of downloads option,if either date selected older then 3 month from current month or date not selected */ -->
<div *ngIf="displayWarningMsg && !dataAlreadyPresent" >
    <div class="flex justify-end mb-1">
        <span class="flex items-center " mat-dialog-close mat-icon-button
            style="cursor: pointer">
            <mat-icon [svgIcon]="'custom:close'"></mat-icon>
        </span>
    </div>
    <hr class="w-full my-4">
    <div class="flex flex-col">
        <div class="flex justify-start align-center p-4 warning-msg">
            Downloading may take approximately {{estimatedTime}}. Do you want to proceed with the download? Click 'Proceed' to continue or 'Cancel' to abort.</div>
    </div>
    <div class="flex justify-end gap-4">
        <button class="flex justify-center btn-look" (click)="proceedToDownload()">
            <span class="text-look">{{dashboardService.translate('Proceed')}}</span>
        </button>
        <button class="flex justify-center btn-look" (click)="closeWindow()">
            <span class="text-look">{{dashboardService.translate('Cancel')}}</span>
        </button>
    </div>
</div>

<div *ngIf="dataAlreadyPresent" >
    <div class="flex justify-end mb-1">
        <span class="flex items-center " mat-dialog-close mat-icon-button
            style="cursor: pointer">
            <mat-icon [svgIcon]="'custom:close'"></mat-icon>
        </span>
    </div>
    <hr class="w-full my-4">
    <div class="flex flex-col">
        <div class="flex justify-start align-center p-4 warning-msg">This record already exists. Would you like to navigate directly to the Report Module?</div>
    </div>
    <div class="flex justify-end gap-4">
        <button class="flex justify-center btn-look w-[151px]" (click)="redirectReportModule()">
            <span class="text-look">{{dashboardService.translate('Go to Reports')}}</span>
        </button>
        <button class="flex justify-center btn-look" (click)="closeWindow()">
            <span class="text-look">{{dashboardService.translate('Dismiss')}}</span>
        </button>
    </div>
</div>
